import { Modal, Row, Col, message } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import styles from "../../../../constants/styles.json";
import sortBy from "lodash/sortBy";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import db from "../../../../database";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import {
  discardCouponService,
  discardGiftCard,
  getProductsNearbyStockService,
  upsertGiftCardTransaction,
  unlinkTill,
  upsertCreditTransaction,
  syncSingleProductByValue,
} from "../../../../services";
import { processSync } from "../../../Sync/syncData";
import { getWorkflowData } from "../../../../utils/getWorkflowData";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useSessionStore from "../../../../stores/useSessionStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import useCartStore from "../../../../stores/useCartStore";
import { generateDocumentNo } from "../../../../utils/documentSequenceUtils";
import messages from "../../../../errors/messages.en-IN.json";

const usePreorderHandlers = ({
  cart,
  setCart,
  tillData,
  posConfig,
  amount,
  setAmount,
  overPayedAmount,
  setOverPayedAmount,
  pricePrecision,
  giftCardData,
  setGiftCardData,
  handleLoyaltyPayment,
  documentSequence,
  setDocumnetSequence,
  orderType,
  deleteCart,
  getFilteredPaymentMethods,
  setShowPayments,
  showPayments,
  startIndex,
  setStartIndex,
  setSelectedKeys,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  setSelectedDocumentType,
  hasShownCustomerModalRef,
  keyboard,
  searchInputRef,
  debounceRef,
  enterRef,
  productSearchInput,
  setProductSearchInput,
  setCustomMixItems,
  setGroupQty,
  setActiveInput,
  setShowInputFields,
  selectParkedBill,
  openDisplayParkedBillModal,
  discardParkedBill,
  setParkedBillSearchInput,
  filterdParkedList,
  setFilterdParkedList,
  mapParkedList,
  showOrderHistory,
  setSyncLoad,
  resetProgress,
  selectedSaleTypeData,
  selectedProductInCart,
  setStockList,
  setOptions,
  setProductMap,
  isOnline,
  isLocked,
  dispatchEvent,
  setKeyValue,
  setSelectedProductForNotes,
  setCalendarVisible,
  selectedDate,
  setSelectedDate,
  setCalendarVisibleMap,
  setIsInputFocused,
  syncOrders,
}) => {
  const domainURL = process.env.REACT_APP_domain;
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const { authHeaders } = getOAuthHeaders();

  const errorMessage = (modalTitle, modalContent) => {
    Modal.error({ title: modalTitle, content: modalContent });
  };

  const handleLogin = () => {
    if (isOnline) {
      const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
      for (let i = 0; i < cookiesToDelete.length; i++) {
        const cookie = cookiesToDelete[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        const domain = "domain=" + domainURL;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
      }
      useSessionStore.getState().setLocked(isLocked);
      const redirectWithIsLocked = `${redirectUrl}sign-in/?username=${authHeaders.username}&readOnly=true`;
      window.location.assign(redirectWithIsLocked);
    } else {
      errorMessage("Sync Failed", "Please check your network connection and try again");
    }
  };

  const onChangeParkedBill = (inputVal) => {
    setParkedBillSearchInput(inputVal);
    keyboard?.current?.setInput(inputVal);
  };

  const handleExpandPerkedData = (record, expandedRowKeys, setExpandedRowKeys) => {
    const nextExpandedKeys = [...expandedRowKeys];
    const index = nextExpandedKeys.indexOf(record.key);
    if (index > -1) {
      nextExpandedKeys.splice(index, 1);
    } else {
      nextExpandedKeys.push(record.key);
    }
    setExpandedRowKeys(nextExpandedKeys);
  };

  const retrieveParkedData = (record) => {
    if (cart.items.length > 0) {
      openDisplayParkedBillModal("retrieve", record);
    } else {
      selectParkedBill(record, "management");
    }
  };

  const discardMessage = (modalTitle, modalContent, record) => {
    Modal.confirm({
      title: modalTitle,
      content: modalContent,
      onOk: () => handleOk(record),
      autoFocusButton: null,
      onCancel: handleCancel,
    });
  };

  const discardGiftCards = async (cartData) => {
    if (giftCardData.length > 0) {
      let details = [];
      cartData?.giftCardData?.map((ele) => {
        details.push(`{
            cardNo: ${ele.number ? `"${ele.number}"` : null}
            referenceNo: "${ele.refId}"
                }`);
      });
      discardGiftCard(null, null, details);
      let upsertDetails = [];
      giftCardData.map((ele) => {
        upsertDetails.push(`{
            cardNo: ${ele.number ? `"${ele.number}"` : null}
            type: "RD"
            referenceNo: "${cartData.referenceId}"
            amount: ${ele.amount * -1}
            cardPin: ${ele?.pin ? `"${ele?.pin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cartData.customer.cwrCustomerId ? `"${cartData.customer.cwrCustomerId}"` : null}
                }`);
      });
      const data = {
        query: `
            mutation {
              upsertGiftCardTransaction(giftCardTransactions: [${upsertDetails}]) {
                status
                message
              }
            }`,
      };
      await upsertGiftCardTransaction(data);
    }
  };

  const processWithParkedBillCancellation = (record) => {
    discardGiftCards(record.parkedCart);
    if (record?.parkedCart?.couponInput?.length > 0) {
      const couponsData = [...record.parkedCart.couponInput];
      const discardCoupon = async (coupon) => {
        try {
          await discardCouponService(coupon.couponCode, coupon.referenceId);
        } catch (error) {
          console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
        }
      };
      couponsData.forEach((coupon) => discardCoupon(coupon));
    }
    let index = record.parkedCart.payments.findIndex((payment) => payment.name.toLowerCase() === "loyalty" && !record.parkedCart.isReturn);
    if (index >= 0) handleLoyaltyPayment(record.parkedCart.payments[index], record.parkedCart);
    setGiftCardData([]);
    discardParkedBill(record);
    setParkedBillSearchInput("");
    const allParkedList = useSessionStore.getState().parkedList || [];
    setFilterdParkedList(mapParkedList(allParkedList));
    const productSearchInput = document.getElementById("sm-product-search");
    if (productSearchInput) {
      setTimeout(() => {
        productSearchInput.focus();
      }, 300);
    }
  };

  const handleOk = async (record) => {
    const { workflowRules, approvers } = await getWorkflowData();
    const cancelParkedBillRule = workflowRules.find((res) => res.eventName === "Cancel Parked Bill");
    if (cancelParkedBillRule) {
      dispatchEvent(cancelParkedBillRule.eventName, cancelParkedBillRule.ruleName, cancelParkedBillRule.ruleCondition, approvers, null, async (eventData) => {
        if (eventData?.approvalGranted) {
          await processWithParkedBillCancellation(record);
        } else {
          Modal.error({ title: "Approval Required", content: "The cancellation request was not approved." });
        }
      });
    } else {
      await processWithParkedBillCancellation(record);
    }
  };

  const handleCancel = () => {
    Modal.destroyAll();
    const productSearchInput = document.getElementById("sm-product-search");
    if (productSearchInput) {
      setTimeout(() => {
        productSearchInput.focus();
      }, 300);
    }
  };

  const clearCartData = async (type) => {
    const tillSession = useSessionStore.getState().tillSession;
    const tillSessionId = tillSession.tillSessionId;
    const newDocumentSequence = cart.parked === "Y" ? documentSequence : documentSequence + 1;
    let cartToDb = JSON.parse(JSON.stringify(cart));
    cartToDb.orderTime = dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss");
    cartToDb.createdBy = tillData.tillAccess.csUserId;
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
    cartToDb.orderDate = dayjs(new Date()).format("DD-MM-YYYY");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart.customer.code;
    cartToDb.tax = 0;
    cartToDb.total = 0;
    cartToDb.docType = "Invoice";
    cartToDb.totalQty = 0;
    cartToDb.couponInput = [];
    cartToDb.discount = 0;
    cartToDb.isReturn = false;
    cartToDb.paid = 0;
    cartToDb.payments = [];
    cartToDb.change = 0;
    cartToDb.items.forEach((item) => {
      item.realWeight = item.weight;
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.isReturn = false;
      item.netList = 0;
      item.discount = 0;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
    });
    setGiftCardData([]);
    if (type === "Layaway") {
      const cancelledSeqLW = useSessionStore.getState().cancelledOrderSequence;
      if (cancelledSeqLW) {
        cartToDb.documentno = generateDocumentNo(cancelledSeqLW);
        useSessionStore.getState().incrementCancelledOrderSequence();
        deleteCart(true, "ownSequence");
      } else {
        deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
      }
      await db.orders.put(cartToDb);
      if (posConfig?.disableOfflineBilling === "Y") {
        syncOrders("auto");
      }
    } else {
      const cancelledSeq = useSessionStore.getState().cancelledOrderSequence;
      if (cancelledSeq) {
        cartToDb.documentno = generateDocumentNo(cancelledSeq);
        useSessionStore.getState().incrementCancelledOrderSequence();
        deleteCart(true, "ownSequence");
      } else {
        useSessionStore.getState().setDocumentSequence(newDocumentSequence);
        setDocumnetSequence(newDocumentSequence);
        deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
      }
    }
    // Persist and sync the cancelled-order snapshot regardless of type — this ran
    // unconditionally before the cancelled-sequence feature was added; a later
    // refactor accidentally nested it inside the non-Layaway branch only, which
    // silently dropped the cancel record (and its server sync) for Layaway/Advance
    // cancellations.
    await db.orders.put(cartToDb);
    if (posConfig?.disableOfflineBilling === "Y") {
      syncOrders("auto");
    }
  };

  const cancelOrder = async () => {
    setSelectedDocumentType("Invoice");
    let pmList = getFilteredPaymentMethods() || [];
    let payments =
      pmList.length > 5
        ? sortBy(pmList, "sequenceNo").slice(
            0,
            tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && pmList.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5
          )
        : pmList;
    setShowPayments(payments);

    if (cart?.couponInput?.length > 0) {
      const couponsData = [...cart.couponInput];
      const discardCoupon = async (coupon) => {
        try {
          await discardCouponService(coupon.couponCode, coupon.referenceId);
          console.debug(`Coupon ${coupon.couponCode} discarded`);
        } catch (error) {
          console.error(`Error discarding coupon ${coupon.couponCode}:`, error);
        }
      };
      couponsData.forEach((coupon) => discardCoupon(coupon));
    }

    discardGiftCards(cart);
    let index = cart.payments.findIndex((payment) => payment.name.toLowerCase() === "loyalty" && !cart.isReturn);
    if (index >= 0) handleLoyaltyPayment(cart.payments[index], cart);
    clearCartData(cart.type);
    hasShownCustomerModalRef.current = false;
    useTransactionStore.getState().setCouponAdditionalInfo(null);
    setShowInputFields(false);
    setCustomMixItems([]);
    setGroupQty(1);
    setActiveInput("search");
    setProductSearchInput("");
    if (searchInputRef?.current) searchInputRef.current.focus();
  };

  const deleteProductModal = () => {
    // In exchange mode, gate checks on the exchange cart instead of the
    // return cart. Ported from roadmap 1ec48549.
    const isExchangeMode = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
    const exchangeCartObj = isExchangeMode ? useCartStore.getState().exchangeCart || null : null;
    const activeCart = isExchangeMode && exchangeCartObj?.items?.length > 0 ? exchangeCartObj : cart;
    if (activeCart.payments?.length > 0) {
      message.warning(`${messages.errors.cart.delete_payment_first}`);
      return;
    }
    if (activeCart.items.length > 0) {
      Modal.confirm({
        title: "This action will remove all products from the cart, including the selected customer.Do you wish to proceed?",
        icon: null,
        cancelText: "No",
        okText: "Yes",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        async onOk() {
          const { workflowRules, approvers } = await getWorkflowData();
          const cancelParkedBillRule = workflowRules.find((res) => res.eventName === "Cancel Parked Bill");
          if (cancelParkedBillRule && cart.parked === "Y" && cart.isRetrived === "Y") {
            dispatchEvent(cancelParkedBillRule.eventName, cancelParkedBillRule.ruleName, cancelParkedBillRule.ruleCondition, approvers, null, async (eventData) => {
              if (eventData?.approvalGranted) {
                await cancelOrder();
              } else {
                Modal.error({ title: "Approval Required", content: "The cancellation request was not approved." });
              }
            });
          } else {
            await cancelOrder();
          }
        },
      });
    }
  };

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number ? ele.number : null,
            type: "RD",
            referenceNo: cart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin ? ele.pin : null,
          }));
          const upsertDetailsStrings = upsertDetails.map(
            (detail) => `{
            cardNo: ${detail.cardNo ? `"${detail.cardNo}"` : null},
            type: "${detail.type}",
            referenceNo: "${detail.referenceNo}",
            amount: ${detail.amount},
            cardPin: ${detail.cardPin ? `"${detail.cardPin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
          }`
          );
          const data = {
            query: `
                mutation {
                  upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) {
                    status
                    message
                  }
                }`,
          };
          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({
                number: detail.cardNo,
                amount: detail.amount,
                redemptionId: uniqId,
                pin: detail.cardPin ? detail.cardPin : null,
              });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.name.toLowerCase() === "credit" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          const trxData = [
            {
              b2cCustomerId: cart?.customer?.cwrCustomerId,
              trxDate: dayjs(new Date()).format("YYYY-MM-DD"),
              trxAmt: Number(payment.amount) * -1,
              openingAmt: cart?.customer?.creditBalance - Number(payment.amount),
              closingAmt: cart?.customer?.creditBalance,
              type: "CR",
              cwrTillId: null,
              sOrderId: null,
              referenceNo: cart?.referenceId,
            },
          ];
          await upsertCreditTransaction(trxData);
        } else if (payment.name.toLowerCase() === "loyalty" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, cart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid = paid + parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid = paid + parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        cart.payments = results.filter((result) => result !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") {
          cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        }
        setCart(cart);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleKeyvalue = async (key) => {
    if (key === "0") {
      setSelectedPaymentMethod({});
      setKeyValue("0");
      setSelectedKeys([]);
    }
    if (key === "1") {
      filterdParkedList?.map((item) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
      setKeyValue("1");
      setSelectedKeys([]);
    }
    if (key === "2") {
      setKeyValue("2");
      setSelectedKeys([]);
    }
    if (key === "3") {
      showOrderHistory();
      setKeyValue("3");
      setSelectedKeys([]);
    }
    if (key === "4") {
      setSyncLoad(true);
      let tillDataState = useAuthStore.getState().tillData;
      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillDataState.tillAccess.csBunit.b2cCustomer;
      setCart({ ...cart, customer: defaultCustomer });
      await processSync(tillDataState, "Incremental Sync");
      setSyncLoad(false);
      resetProgress();
    }
    if (key === "7") {
      setKeyValue("7");
      setSelectedKeys([]);
    }
    if (key === "parked-bill") {
      const parkedList = useSessionStore.getState().parkedList || [];
      const updatedParkedList = parkedList.map((item) => ({
        ...item,
        status: "Parked",
        key: uuidv4().replace(/-/g, "").toUpperCase(),
        customer: item?.parkedCart?.customer?.name.toLowerCase(),
        qty: item.parkedCart.totalQty,
      }));
      setFilterdParkedList(updatedParkedList);
      useSessionStore.getState().setParkedList(updatedParkedList);
    }
  };

  const showConfirm = () => {
    return new Promise((resolve) => {
      Modal.confirm({
        title: (
          <>
            <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
          </>
        ),
        icon: null,
        content: (
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "1px solid #fff",
              borderRadius: "7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Bill Amount</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>{parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}</p>
              </Col>
            </Row>
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Tendered</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>{parseFloat(amount || 0).toFixed(pricePrecision)}</p>
              </Col>
            </Row>
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Received</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>{Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}</p>
              </Col>
            </Row>
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Change Due</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>
                  {cart.paid + parseFloat(amount || 0) - Math.abs(cart.total) > 0
                    ? (cart.paid + parseFloat(amount || 0) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                    : cart?.change <= 0
                      ? "0.00"
                      : cart?.change}
                </p>
              </Col>
            </Row>
          </div>
        ),
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        cancelButtonProps: { style: { borderRadius: "5px" } },
        okButtonProps: { style: { borderRadius: "5px" } },
      });
    });
  };

  const showMoreItems = () => {
    const pmList = tillData.tillAccess.csBunit.paymentMethodList;
    let paymentDetails = getFilteredPaymentMethods();
    if (cart?.docType === "Advance") paymentDetails = [...paymentDetails];
    const isRefundScenario = amount < 0 && selectedPaymentMethod?.name?.toLowerCase() === "cash";
    const maxPaymentsToShow = isRefundScenario ? 3 : 4;
    let itemsPerPage =
      tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && pmList.length === maxPaymentsToShow
        ? maxPaymentsToShow
        : cart.layAway === "Y"
          ? maxPaymentsToShow
          : maxPaymentsToShow;
    if (startIndex + itemsPerPage >= paymentDetails.length) {
      if (startIndex < paymentDetails.length) {
        setShowPayments(paymentDetails.slice(startIndex, paymentDetails.length));
        setStartIndex(paymentDetails.length);
      } else {
        setShowPayments(paymentDetails.slice(0, itemsPerPage));
        setStartIndex(itemsPerPage);
      }
    } else {
      setShowPayments(paymentDetails.slice(startIndex, itemsPerPage + startIndex));
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const confirmUnlink = () => {
    Modal.confirm({
      title: "Confirm Unlink",
      content: "Are you sure you want to unlink the till?",
      okText: "Yes",
      cancelText: "Cancel",
      okButtonProps: { style: { display: "inline-block" } },
      onOk: async () => {
        await tillUnlink();
      },
      onCancel: () => {
        console.debug("Unlink operation cancelled");
      },
    });
  };

  const tillUnlink = async () => {
    const unlinkTillAPI = async () => {
      try {
        let id = tillData.tillAccess.cwrTill.cwrTillID;
        const response = await unlinkTill(id);
        if (response.data.data.unlinkTill.status === "200") {
          localStorage.clear();
          await Promise.all(
            db.tables.map(async (table) => {
              await table.clear();
            })
          );
        }
        document.cookie.split(";").forEach((cookie) => {
          document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`);
        });
        useSessionStore.getState().setUnlink(false);
        window.location.assign(`${redirectUrl}sign-in`);
      } catch (error) {
        console.error("Error in unlinkTillAPI:", error);
      }
    };
    await unlinkTillAPI();
  };

  const getProductNearByStock = async () => {
    try {
      const stockInputValues = {
        query: `
          query {
            getProductsNearbyStock(
              bUnitId: "${tillData.tillAccess.csBunit.csBunitId}",
              code: "${selectedProductInCart.value}"
            ) {
              csBunitId
              value
              name
              totalQty
              stores {
                csNearbyStoreId
                name
                nearbybUnitId
                viewStock
                isIssue
                warehouse {
                  mWarehouseID
                  name
                  value
                  storageBin {
                    mStoragebinID
                    name
                    stocks {
                      mStockID
                      qtyonhand
                      product {
                        mProductId
                        value
                        name
                        upc
                        uom { csUomId name }
                        productCategory { mProductCategoryId value name }
                      }
                      batch {
                        mBatchId batchno upc price startdate enddate life
                        purchasePrice listPrice purchaseDate
                      }
                    }
                    totalQty
                  }
                }
              }
            }
          }
        `,
      };
      const response = await getProductsNearbyStockService(stockInputValues);
      const { stores, totalQty, csBunitId } = response.data.data.getProductsNearbyStock;
      const currentStock = {
        csNearbyStoreId: "53F4FBEBDAB94C4AB205B7415EBD739E",
        name: tillData.tillAccess.csBunit.mWarehouse.name,
        nearbybUnitId: "EEF9FADCE0D74AE3B8B6096E6C35B6AA",
        viewStock: "Y",
        isIssue: "Y",
        warehouse: {
          mWarehouseID: "79FD0E516E4F4C5F9A7932F0C5C82C92",
          name: tillData.tillAccess.csBunit.mWarehouse.name,
          value: "Central WH TTLLC",
          storageBin: { mStoragebinID: "09581CA09C154830A20B88370C501FD6", name: "Central Warehouse", stocks: [], totalQty: totalQty || 0 },
        },
      };
      const isStorePresent = stores?.some((store) => store?.nearbybUnitId === csBunitId);
      setStockList(isStorePresent ? stores : [currentStock, ...stores]);
    } catch (error) {
      console.error("Error fetching nearby stock:", error);
    }
  };

  const handleViewStockClick = () => {
    getProductNearByStock();
  };

  const onChangeInput = async (event) => {
    const inputVal = event.target.value;
    setProductSearchInput(inputVal);
    localStorage.setItem("productName", inputVal);
    keyboard?.current?.setInput(inputVal);
    if (posConfig?.product_search_display_mode === "dropdown") {
      if (inputVal.trim() === "") {
        setOptions([]);
        setProductMap({});
        return;
      }
      // await handleSearch(inputVal);
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        handleSearch(inputVal);
      }, 1000); // 🔥 smooth delay
    }
  };

  const handleSearch = async (data) => {
    const posConfigState = usePOSConfigStore.getState().posConfig;
    const search = data.toLowerCase();
    if (!data) {
      setOptions([]);
      return;
    }
    let products;
    if (posConfigState?.is_smart_product_search === "Y") {
      products = await db.products
        .filter((product) => product.isactive == true)
        .filter((product) => product.productSegment !== "BG")
        .filter((product) => product.value?.toLowerCase() === data)
        .limit(20)
        .toArray();
      if (products.length === 0) {
        products = await db.products
          .filter((product) => product.isactive == true)
          .filter((product) => product.productSegment !== "BG")
          .filter((product) => product.upcIndex === data || product.upc === data || product.name?.toLowerCase().includes(search))
          .limit(20)
          .toArray();
      }
    } else {
      products = await db.products
        .filter((product) => product.isactive == true)
        .filter((product) => product.productSegment !== "BG")
        .filter((product) => product.name?.toLowerCase().includes(search) || product.upcIndex === data || product.upc === data || product.value === data)
        .limit(20)
        .toArray();
    }
    // Cache miss → try on-demand single-product sync once (roadmap ad6b7339).
    if (products.length === 0 && String(data).trim().length >= 2) {
      const tillData = useAuthStore.getState().tillData;
      if (tillData?.tillAccess?.csBunit?.csBunitId) {
        try {
          const synced = await syncSingleProductByValue(tillData, uuidv4(), tillData?.tillAccess?.cwrTill?.cwrTillID, String(data).trim());
          if (synced) {
            // Re-run the same search with the newly-synced product now in DB.
            products =
              posConfigState?.is_smart_product_search === "Y"
                ? await db.products
                    .filter((product) => product.isactive == true)
                    .filter((product) => product.productSegment !== "BG")
                    .filter((product) => product.value?.toLowerCase() === data)
                    .limit(20)
                    .toArray()
                : await db.products
                    .filter((product) => product.isactive == true)
                    .filter((product) => product.productSegment !== "BG")
                    .filter((product) => product.name?.toLowerCase().includes(search) || product.upcIndex === data || product.upc === data || product.value === data)
                    .limit(20)
                    .toArray();
          }
        } catch (err) {
          console.warn("[PreOrder] single-product sync failed:", err?.message);
        }
      }
    }

    if (products.length > 0) {
      const filteredOptions = products.map((item) => ({ label: `${item.value} - ${item.name}`, value: item.value }));
      const map = {};
      products.forEach((item) => {
        map[item.value] = item;
      });
      setOptions(filteredOptions);
      setProductMap(map);
    } else {
      setOptions([]);
      setProductMap({});
    }
  };

  const handleDateSelect = (record) => (date, dateString) => {
    let updatedCart;
    setSelectedDate(date);
    setCalendarVisible(false);
    if (searchInputRef?.current) searchInputRef?.current.focus();
    if (record !== null && cart.items.length > 0) {
      updatedCart = { ...cart };
      let index = updatedCart.items.findIndex((res) => res.lineId === record.lineId);
      if (index >= 0) updatedCart.items[index].deliveryDate = date && date.format("DD-MM-YYYY HH:mm:ss");
      toggleCalendar(record.lineId);
    } else {
      updatedCart = {
        ...cart,
        deliveryDate: (date && date.format("DD-MM-YYYY HH:mm:ss")) || "",
        deliveryDatePromised: (date && dateString) || "",
      };
    }
    setSelectedProductForNotes(null);
    setCart(updatedCart);
    setIsInputFocused(false);
    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (updatedCart.items.length === 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = { ...orderTimeDetails, paymentStartTime: "", orderStartTime: dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss") };
    } else if (updatedCart.items.length > 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = { ...orderTimeDetails, paymentStartTime: "" };
    }
    if (updatedCart.description === "") orderTimeDetails = { ...orderTimeDetails, paymentStartTime: "", orderStartTime: "" };
    usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
  };

  const toggleCalendar = (key) => {
    setCalendarVisibleMap((prev) => ({ ...prev, [key]: !prev[key] || false }));
  };

  const handleSelectProduct = async () => {
    await db.products
      .filter((product) => product.isactive == true)
      .filter((product) => product.productSegment !== "BG")
      .toArray()
      .then((productsFetched) => {
        const lowerCaseSearchInput = productSearchInput?.toLowerCase() || "";
        const filteredProducts = productsFetched.filter(
          (product) =>
            product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
            product?.batchIndex === lowerCaseSearchInput ||
            product?.upcIndex === lowerCaseSearchInput ||
            product?.value === lowerCaseSearchInput ||
            product?.upc === lowerCaseSearchInput
        );
        if (filteredProducts.length === 0) {
          message.info("No products found matching the search criteria");
        } else {
          return filteredProducts;
        }
      });
  };

  const showPreviousItems = () => {};

  const modulo = (a, b) => a - b * Math.floor(a / b);

  return {
    errorMessage,
    handleLogin,
    onChangeParkedBill,
    handleExpandPerkedData,
    retrieveParkedData,
    discardMessage,
    discardGiftCards,
    processWithParkedBillCancellation,
    handleOk,
    handleCancel,
    clearCartData,
    cancelOrder,
    deleteProductModal,
    handleDeletePayment,
    handleKeyvalue,
    showConfirm,
    showMoreItems,
    showPreviousItems,
    confirmUnlink,
    tillUnlink,
    getProductNearByStock,
    handleViewStockClick,
    onChangeInput,
    handleSearch,
    handleDateSelect,
    toggleCalendar,
    handleSelectProduct,
    modulo,
  };
};

export default usePreorderHandlers;
